import React from "react";
import Modal from "react-bootstrap/Modal";

const GenMasterModal = ({
  show,
  onClose,
  title,
  name,
  setName,
  nameError,
  onSubmit,
  disableSubmit,
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Add {title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="input-block local-forms">
          <label>
            Name <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={`Enter ${title} name`}
          />

          {nameError && (
            <div className="error text-danger mt-1">{nameError}</div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenMasterModal;
